import React from 'react';
import { cn } from '@/utils/cn';
import { ActionMenu } from '@/components/ui/ActionMenu';
import { TablePagination } from '@/components/ui/TablePagination';
import { CardList } from '@/components/ui/CardList';

export function ProjectPersonnelList({ personnel }: { personnel: any[] }) {
  return (
    <div className="bg-white rounded-md border border-slate-100  overflow-hidden">
      <div className="p-4 border-b border-slate-50">
        <h3 className="text-sm font-normal text-slate-900 tracking-wider">Danh sách nhân sự ({personnel.length})</h3>
      </div>

      {/* Desktop Table */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-slate-50/50 text-xs font-normal text-slate-400 border-b border-slate-100">
              <th className="py-3 px-4 w-10 text-center font-normal">#</th>
              <th className="py-3 px-4 font-normal">Nhân sự</th>
              <th className="py-3 px-4 font-normal">Chức vụ</th>
              <th className="py-3 px-4 text-center font-normal">Phân loại</th>
              <th className="py-3 px-4 font-normal">Đơn vị / Công ty</th>
              <th className="py-3 px-4 text-center font-normal">Giờ công</th>
              <th className="py-3 px-4 text-center font-normal">Trạng thái</th>
              <th className="py-3 px-4 w-10 text-center font-normal">Hành động</th>
            </tr>
          </thead>
          <tbody className="text-xs lg:text-sm divide-y divide-slate-50">
            {personnel.map((p) => (
              <tr key={p.id} className="hover:bg-slate-50/50 transition-colors group">
                <td className="py-4 px-4 text-slate-400 font-normal">{p.index}</td>
                <td className="py-4 px-4">
                  <div className="flex items-center gap-3">
                    <img src={p.avatar} alt="" className="w-8 h-8 rounded-full border border-slate-100 shrink-0" />
                    <div className="flex flex-col min-w-0">
                      <div className="flex items-center gap-2">
                        <span className="font-normal text-slate-700 truncate group-hover:text-emerald-600 transition-colors cursor-pointer">{p.name}</span>
                        {p.badges?.map(b => (
                          <span key={b} className="text-xs px-1 rounded bg-emerald-50 text-emerald-600 font-normal">{b}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="py-4 px-4 font-normal text-slate-600">{p.role}</td>
                <td className="py-4 px-4">
                   <span className={cn("px-2 py-0.5 rounded-md text-xs font-normal", p.typeColor)}>{p.type}</span>
                </td>
                <td className="py-4 px-4 font-normal text-slate-500">{p.unit}</td>
                <td className="py-4 px-4 text-center font-normal text-slate-700">{p.workHours}</td>
                <td className="py-4 px-4 text-center">
                   <span className={cn("px-2 py-0.5 rounded-md text-xs font-normal", p.statusColor)}>{p.status}</span>
                </td>
                <td className="py-4 px-4 text-center">
                   <ActionMenu items={[{ label: 'Hồ sơ chi tiết' }, { label: 'Chỉnh sửa' }, { label: 'Xóa', destructive: true }]} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Card List */}
      <div className="lg:hidden p-4">
        <CardList 
          items={personnel}
          renderCard={(p) => (
            <div key={p.id} className="bg-white p-3 rounded-md border border-slate-100 space-y-4">
              <div className="flex justify-between items-start">
                <div className="flex items-center gap-3">
                  <img src={p.avatar} alt="" className="w-10 h-10 rounded-full" />
                  <div className="space-y-0.5">
                    <h4 className="text-xs font-normal text-slate-900">{p.name}</h4>
                    <p className="text-xs font-normal text-slate-400">{p.role}</p>
                  </div>
                </div>
                <ActionMenu items={[{ label: 'Hồ sơ chi tiết' }, { label: 'Chỉnh sửa' }, { label: 'Xóa', destructive: true }]} />
              </div>
              <div className="grid grid-cols-2 gap-4 border-t border-slate-50 pt-3">
                 <div className="space-y-1">
                    <p className="text-xs text-slate-400 font-normal">Đơn vị</p>
                    <p className="text-xs font-normal text-slate-700 truncate">{p.unit}</p>
                 </div>
                 <div className="space-y-1 text-right">
                    <p className="text-xs text-slate-400 font-normal">Giờ công</p>
                    <p className="text-xs font-normal text-slate-900">{p.workHours} giờ</p>
                 </div>
              </div>
              <div className="flex justify-between items-center bg-slate-50/50 p-2 rounded-md">
                 <span className={cn("px-2 py-0.5 rounded-md text-xs font-normal", p.typeColor)}>{p.type}</span>
                 <span className={cn("px-2 py-0.5 rounded-md text-xs font-normal", p.statusColor)}>{p.status}</span>
              </div>
            </div>
          )}
        />
      </div>

      <div className="px-4 border-t border-slate-50 bg-slate-50/30">
        <TablePagination currentPage={1} totalItems={36} pageSize={8} onPageChange={() => {}} itemLabel="nhân sự" />
      </div>
    </div>
  );
}
